import { useEffect, useState } from 'react';
import MobileOrDesktopDialog from '@/components/common/mobileOrDesktopDialog';
import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
import { IVehicleDetails } from '@/types';
import { useSelector, useDispatch } from 'react-redux';
import Router from '@/components/common/router';
import { getUserDetails } from '@/store/modules/userDataSlice';

import Carousel from '../carCardCarousel';
import * as Styles from './styles';
import { trackEventAPI, viewPageAPI } from '@/analytics/middleware';
import {
    TAP_BTN_NOT_THIS_CAR,
    VIEW_PAGE_CAR_DETAILS_MODAL,
} from '@/analytics/events';
import useQueryParam from '@/hooks/useQueryParam';
import { useRouter } from 'next/router';
import useSavedVehicleInfoCheck from '../../hooks/useSavedVehicleCheck';

interface SavedAssetModalProps {
    show: boolean;
    close: () => void;
    savedAssets?: IVehicleDetails[];
    savedAssetClickHandler: (asset: IVehicleDetails) => void;
    addNewAssetClick: () => void;
    isNewBookingFlow?: boolean;
    editCarModal?: boolean;
}

export default function SavedAssetModal({
    show,
    close,
    savedAssets = [],
    savedAssetClickHandler,
    addNewAssetClick,
    isNewBookingFlow = false,
    editCarModal = false,
}: SavedAssetModalProps) {
    const { carNumber } = useSavedVehicleInfoCheck();
    const [showLoader, setShowLoader] = useState(false);
    const currentCarNumber = '';

    const index = Math.max(
        0,
        savedAssets?.findIndex(
            (asset) => asset?.vehicle_number === (currentCarNumber || carNumber)
        ) ?? -1
    );
    const [selectedSavedAsset, setSelectedSavedAsset] = useState(index);

    const redirectedFrom = useQueryParam('redirect_from') || '';
    console.log('test', index, selectedSavedAsset, savedAssets, editCarModal);

    const onClickSavedAsset = async () => {
        sessionStorage.setItem('vehicleModalAutoOpened', 'true');
        setShowLoader(true);
        savedAssetClickHandler(savedAssets[selectedSavedAsset]);
    };

    const onClickAddNewAsset = () => {
        trackEventAPI({
            event_name: TAP_BTN_NOT_THIS_CAR,
            customAttributes: {},
            isFakeDoor: true,
        });
        //close();
        addNewAssetClick();
    };

    const getCta = () => {
        if (editCarModal) {
            return 'Update Car';
        }
        // const cta = ['sr-pricecheck-cta', 'pricecheckcta'].includes(
        //     redirectedFrom
        // )
        //     ? 'Looks good'
        //     : 'Looks good';
        return 'Looks good';
    };

    useEffect(() => {
        if (show) {
            viewPageAPI({
                event_name: VIEW_PAGE_CAR_DETAILS_MODAL,
                customAttributes: {
                    adsc_asset_saved: savedAssets.length > 0,
                },
                isFakeDoor: true,
            });
        }
    }, [show]);
    return (
        <>
            <MobileOrDesktopDialog
                show={show}
                onClose={close}
                //hideClose
                title={
                    editCarModal
                        ? 'Edit your car details'
                        : 'Looks like we have your car details. Check if they are correct before proceeding with your booking.'
                }
            >
                <div
                    style={{
                        marginBottom: '24px',
                    }}
                >
                    {editCarModal && (
                        <Styles.WarningMessage>
                            Just a heads-up: Changing the car might change the
                            price as well
                        </Styles.WarningMessage>
                    )}
                </div>

                <Styles.Container>
                    <Carousel
                        activeIndex={selectedSavedAsset}
                        setActiveIndex={setSelectedSavedAsset}
                        savedAssets={savedAssets}
                    />

                    <Styles.CTAContainer>
                        <PrimaryButton
                            onClick={onClickSavedAsset}
                            disabled={showLoader}
                            loading={showLoader}
                        >
                            {getCta()}
                        </PrimaryButton>

                        <Styles.Link onClick={onClickAddNewAsset}>
                            Not this car? Add a new one
                        </Styles.Link>
                    </Styles.CTAContainer>
                </Styles.Container>
            </MobileOrDesktopDialog>
        </>
    );
}
